import { CoreMenu } from '@core/types';

export const menu: CoreMenu[] = [
  {
    id: 'apps',
    type: 'section',
    title: '',
    translate: '',
    icon: 'package',
    children: [
      {
        id: 'default',
        title: 'Gösterge Paneli',
        translate: 'Menu.Dashboard',
        type: 'item',
        icon: 'pie-chart',
        url: 'home/default'
      },
      {
        id: 'ticket',
        title: 'Bilet',
        translate: 'Menu.Ticket',
        icon: 'info',
        type: 'collapsible',
        children: [
          {
            id: 'save-ticket',
            title: 'Bilet ekle',
            translate: 'Menu.AddTicket',
            type: 'item',
            icon: 'folder',
            url: 'home/save-ticket'
          },
          {
            id: 'TicketList',
            title: 'Bilet listesi',
            translate: 'Menu.TicketList',
            type: 'item',
            icon: 'folder',
            url: 'home/ticket-list'
          }
        ]
      },
      {
        id: 'projects',
        title: 'Projeler',
        translate: 'Menu.projects',
        type: 'item',
        icon: 'pie-chart',
        url: 'home/project-detail-list'
      },
    ]
  }
];
